import React from 'react'
import clsx from 'clsx'
import { Box, Icon } from '@node-space/ui-components'
import { CSATFeedbackValue, CSATFeedbackValueType } from './types'

export type CSATIconType = {
  size?: number
}

export type CSATIconProps = CSATIconType & {
  name: CSATFeedbackValueType
  selected: boolean
}

const IconBackground = ({ className }: { className: string }) => {
  return (
    <Box
      className={clsx(
        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full size-[calc(100%-5px)] z-[-1]',
        className
      )}
    ></Box>
  )
}

export const CSATIcon = ({ name, selected }: CSATIconProps) => {
  if (name === CSATFeedbackValue.BAD)
    return (
      <Box className="relative">
        {selected && (
          <IconBackground className="bg-surface-status-error color-accent-status-error"></IconBackground>
        )}
        <Icon size="large" name="SmileySad" />
      </Box>
    )
  if (name === CSATFeedbackValue.OKAY)
    return (
      <Box className="relative">
        {selected && (
          <IconBackground className="bg-surface-feature color-accent-feature"></IconBackground>
        )}
        <Icon size="large" name="SmileyMeh" />
      </Box>
    )
  return (
    <Box className="relative">
      {selected && (
        <IconBackground className="bg-surface-status-success color-accent-status-success"></IconBackground>
      )}
      <Icon size="large" name="Smiley" />
    </Box>
  )
}
